import { Input, Select } from '@/components/ui/FormControls';
import { useState } from 'react';
import { useProducts } from '@/hooks/useProducts';
import { purchaseInputClass as input } from './PurchasePaymentFields';
export default function PurchaseItemReference({
  value,
  onSelect,
}: {
  value?: string | null;
  onSelect: (id: string | null, description?: string, cost?: number) => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-2 rounded-xl bg-muted/20 p-3">
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          className="min-h-11 text-sm text-primary"
          onClick={() => setOpen(!open)}
        >
          {open
            ? 'Hide product search'
            : value
              ? 'Change product reference'
              : '+ Use a product reference (optional)'}
        </button>
        {value && (
          <button
            type="button"
            className="min-h-11 text-sm text-muted-foreground"
            onClick={() => onSelect(null)}
          >
            Clear reference
          </button>
        )}
      </div>
      {open && <Choices value={value} onSelect={onSelect} />}
    </div>
  );
}
function Choices({
  value,
  onSelect,
}: {
  value?: string | null;
  onSelect: (id: string | null, description?: string, cost?: number) => void;
}) {
  const query = useProducts();
  const [search, setSearch] = useState('');
  const rows = (query.data || []).flatMap((p) =>
    p.product_variants
      .filter((v) => v.is_active)
      .map((v) => ({
        ...v,
        label: `${p.name} · ${v.size}${v.color ? ' / ' + v.color : ''} · ${v.sku}`,
      })),
  );
  const visible = rows.filter((r) => r.label.toLowerCase().includes(search.toLowerCase()));
  return (
    <div className="space-y-2">
      <p className="text-xs text-muted-foreground">
        This copies a description and suggested cost. It does not receive or reserve stock.
      </p>
      <Input
        className={input}
        aria-label="Search product references"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search product name or SKU"
      />
      <Select
        className={input}
        value={value || ''}
        aria-label="Product reference"
        disabled={query.isLoading}
        onChange={(e) => {
          const row = rows.find((r) => r.id === e.target.value);
          if (row) onSelect(row.id, row.label, Number(row.default_cost));
          else onSelect(null);
        }}
      >
        <option value="">{query.isLoading ? 'Loading references…' : 'Choose a reference'}</option>
        {value && !visible.some((r) => r.id === value) && (
          <option value={value}>Saved reference</option>
        )}
        {visible.map((r) => (
          <option key={r.id} value={r.id}>
            {r.label}
          </option>
        ))}
      </Select>
      {query.error && (
        <p role="alert" className="text-sm text-destructive">
          {query.error.message}
          <button
            type="button"
            className="min-h-11 px-2 underline"
            onClick={() => void query.refetch()}
          >
            Retry
          </button>
        </p>
      )}
    </div>
  );
}
